import React, {Component} from 'react';
import './sign-in.styles.css';
import {Link} from "react-router-dom";

class SignIn extends Component {
    render() {
        return (
            <div className="container text-center">
                <div className="mt-5 mb-3">
                    <h1 className="h3 mb-3 font-weight-normal">Sign In</h1>
                </div>
                <form className="form-sign-in mt-5">
                    <div className="form-label-group my-3">
                        <label htmlFor="inputEmail">Email address</label>
                        <input type="email" id="inputEmail" className="form-control" placeholder="Email address"
                               required autoFocus/>
                    </div>

                    <div className="form-label-group">
                        <label htmlFor="inputPassword">Password</label>
                        <input type="password" id="inputPassword" className="form-control" placeholder="Password"
                               required/>
                    </div>
                    <button className="btn btn-lg btn-primary btn-block my-3" type="submit">Sign in</button>
                </form>
                <Link to="/sign-up" className="nav-link">Sign Up</Link>
            </div>
        )
    }
}

export default SignIn;